import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledFormsTemplatesListSection = styled(StyledFlex)`
   width: 388px;
   height: 100%;
`;
StyledFormsTemplatesListSection.displayName = 'StyledFormsTemplatesListSection';
